module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"This account will be disabled.","no":"@:labels.no","question":"Are you sure you want to disable this account ?","title":"Disable Account","yes":"@:labels.yes"},"fr":{"description":"Ce compte sera désactivé.","no":"@:labels.no","question":"Êtes-vous certain de vouloir désactiver ce compte ?","title":"Désactiver compte","yes":"@:labels.yes"}}')
  delete Component.options._Ctor
}
